import type { FC } from "react"
import React from "react"
import { Text, Flex, Tag } from "@chakra-ui/react"

import type { VoteType, Vote } from "query/graphql"
import { getVoteStyles } from "common/helpers/voteStyle"

type ProposalVotesUserProps = {
  voterVote: Vote
}

const ProposalVotesUser: FC<ProposalVotesUserProps> = ({ voterVote }) => {
  const type = voterVote?.type as VoteType

  const voteStyles = getVoteStyles()
  const { color } = voteStyles[type]

  return (
    <Flex
      align="center"
      as="span"
      data-qa="proposals-voting-status"
      direction="row"
    >
      <Text align="center" color="gray.600" pr={2} textStyle="body.regular.md">
        You voted:
      </Text>
      <Tag bg={color} color="white" size="sm">
        {type}
      </Tag>
    </Flex>
  )
}

export default ProposalVotesUser
